import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const Navbar = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://ryc-soluciones-nicaragua.com/api/index.php?getAllCategory=true"
        );

        const categoriesData = response.data.map((item) => ({
          id: item.id,
          slug: item.slug,
          nombre: item.category,
        }));

        setCategories(categoriesData);
      } catch (error) {
        console.error("Error al obtener las categorías:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/productos?search=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark" style={{ backgroundColor: "#00377b" }}>
      <div className="container m-2 position-relative">

        {/* Botón hamburguesa móvil */}
        <button
          className="navbar-toggler position-absolute top-0 start-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Logo escritorio */}
        <Link
          className="navbar-brand d-none d-sm-flex flex-column justify-content-center align-items-center rounded-circle text-light"
          to="/"
          style={{
            width: "70px",
            height: "70px",
            background: "linear-gradient(to bottom right, #00377b, #00377b)",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
            color: "white",
            fontWeight: "bold",
            fontSize: "16px",
            textDecoration: "none",
            textAlign: "center",
            lineHeight: "1.2",
          }}
        >
          RyC
          <div
            style={{
              fontSize: "10px",
              marginTop: "4px",
              textTransform: "uppercase",
              fontWeight: "normal",
            }}
          >
            Nicaragua
          </div>
        </Link>

        {/* Logo + botones móviles centrados */}
        <div className="d-flex d-sm-none justify-content-center align-items-center gap-2 w-100 py-2">
          <Link to="/" className="text-center">
            <img
              src="https://ryc-soluciones-nicaragua.com/imagenes/cropped-cropped-logo-editable-192x192.png"
              alt="RYC Logo"
              style={{ width: "70px", height: "70px", objectFit: "contain" }}
            />
          </Link>

          <Link
            to="/productos/Liquidacion"
            className="btn btn-danger btn-sm d-flex flex-column align-items-center justify-content-center"
            style={{ width: "70px", height: "70px", borderRadius: "50%" }}
          >
            <i className="fa-solid fa-fire" style={{ fontSize: "22px" }}></i>
            <span style={{ fontSize: "11px", lineHeight: "12px", marginTop: "4px" }}>
              Liquidación
            </span>
          </Link>

          <button
            className="btn btn-primary btn-sm d-flex flex-column align-items-center justify-content-center"
            data-bs-toggle="modal"
            data-bs-target="#contactModal"
            style={{ width: "70px", height: "70px", borderRadius: "50%" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="22"
              viewBox="0 -960 960 960"
              width="22"
              fill="currentColor"
            >
              <path d="M480-80q-10 0-19-3.5t-17-10.5q-103-89-166.5-212T214-560q0-110 77.5-187.5T480-825q111 0 188.5 77.5T746-560q0 127-63.5 250T516-94q-8 7-17 10.5t-19 3.5Zm0-410q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41Z" />
            </svg>
            <span style={{ fontSize: "11px", lineHeight: "12px", marginTop: "4px" }}>
              Contáctanos
            </span>
          </button>
        </div>

        {/* Menú colapsable */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {categories.length > 0 ? (
              categories.map((category, index) => {
                const isLiquidacion = category.nombre.toLowerCase() === "liquidacion";
                return (
                  <li
                    className={`nav-item text-nowrap ${index !== categories.length - 1 ? "border-end" : ""}`}
                    key={category.id}
                  >
                    <Link
                      className="nav-link"
                      to={`/productos/${category.nombre.replaceAll(" ", "-")}`}
                      style={{
                        paddingRight: "15px",
                        color: isLiquidacion ? "red" : "white",
                        fontWeight: "normal",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {isLiquidacion && <i className="fa-solid fa-fire"></i>}
                      {category.nombre}
                    </Link>
                  </li>
                );
              })
            ) : (
              <li className="nav-item">
                <span className="nav-link text-light">Cargando...</span>
              </li>
            )}
            <li className="nav-item" style={{ borderLeft: "1px solid white", paddingLeft: "10px" }}>
              <button
                className="nav-link btn btn-link text-light d-flex align-items-center gap-1"
                style={{ cursor: "pointer", textDecoration: "none" }}
                data-bs-toggle="modal"
                data-bs-target="#contactModal"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="16"
                  viewBox="0 -960 960 960"
                  width="16"
                  fill="currentColor"
                >
                  <path d="M480-80q-10 0-19-3.5t-17-10.5q-103-89-166.5-212T214-560q0-110 77.5-187.5T480-825q111 0 188.5 77.5T746-560q0 127-63.5 250T516-94q-8 7-17 10.5t-19 3.5Zm0-410q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41Z" />
                </svg>
                Contáctanos
              </button>
            </li>
          </ul>

          {/* Formulario de búsqueda */}
          <form className="d-flex ms-lg-3 mt-2 mt-lg-0" onSubmit={handleSearchSubmit}>
            <input
              className="form-control me-2"
              type="search"
              placeholder="Buscar producto"
              aria-label="Buscar"
              value={searchQuery}
              onChange={handleSearchChange}
              style={{ width: "100%", minWidth: "200px", maxWidth: "400px" }}
            />
            <button className="btn btn-outline-light" type="submit">
              Buscar
            </button>
          </form>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
